import React, {Component} from 'react';
import ReactModal from 'react-modal';
import TreeView from '../../utils/tree-view';
import noImageAvailable from '../../styles/images/no-image-available.png';
import FinchButton from './FinchButton.js'
import GoogleMap from './GoogleMap.js'
import MetaCartaMap from './MetaCartaMap';
import JsonControl from './JsonControl';
import urlHandler from '../../utils/urlHandler';

class ShowEverythingDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.afterOpen = this.afterOpen.bind(this);
        this.showJson = this.showJson.bind(this);

        // Parse/Process entities response to TreeView data struct
        this.getArrayChildren = this.getArrayChildren.bind(this);
        this.getObjectChildren = this.getObjectChildren.bind(this);

        // Callbacks for TreeView
        this.getNodes = this.getNodes.bind(this);
        this.innerNode = this.innerNode.bind(this);
        this.outerNode = this.outerNode.bind(this);
        this.checkLeaf = this.checkLeaf.bind(this);

        // Handle not loading image
        this.imageError = this.imageError.bind(this);
        this.nodeImageError = this.nodeImageError.bind(this);

        // Formatters
        this.formatStocks = this.formatStocks.bind(this);

        this.state = {
            modalOpen: false,
            data: null,
            rawJson: null,
            content: null,
            headerImage: null,
            type: null,
            showJson: false,
            preferedFields: [
                'id',
                'type',
                'label',
                'description',
                'stocks'
            ],
            testData: '[{"testKey": "This is a value","testKey2": "This is another value"}, \
            {"testKey3": "jfiodsjfid","testKey4": "jgifodjiods"}, {"array1": ["sample 1","sample 2","sample 3", \
            ["embedded unamed array val 1","embedded unamed array val 2"]]}]'
        };

        this.IMG_NODE_VALUE = 'imageUrls';
        this.STOCKS_NODE_VALUE = 'stocks';
        this.LANGUAGE_NODE_VALUE = 'languageFields';
        this.MAP_LON_VALUE = 'longitude';
        this.MAP_LAT_VALUE = 'latitude';

        this.mapDisable = window._mapDisable;
        this.mapMetaCartaUrl = window._mapMetaCartaUrl;
        this.externalUrlsDisable = window._externalUrlsDisable;
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_ShowEverythingDialog');
    }

    close() {
        this.setState({
            modalOpen: false
        })
    };

    open() {
        this.setState({
            modalOpen: true,
            showJson: false
        });
    };

    afterOpen() {
        this.forceUpdate(); // for google map in tree
    };

    showJson() {
        this.setState({
            showJson: !this.state.showJson
        })
    }

    getArrayDisplayValue(arr) {
        let val = '';
        if (arr.length > 0) {
            let type = Object.prototype.toString.call(arr[0]);
            if (type != '[object Object]' && type != '[object Array]') {
                val = arr[0];
            } 
        }
        return val;
    }

    formatStocks(stocks) {
        var arr = [];
        Object.keys(stocks).map((stock) => {
            var str = '';
            if ('tickerSymbol' in stocks[stock]) {
                str += '(' + stocks[stock].tickerSymbol + ') ';
            }
            if ('operatingMic' in stocks[stock]) {
                str += stocks[stock].operatingMic;
            } else if ('exchange' in stocks[stock]) {
                str += stocks[stock].exchange;
            }
            arr.push(str);
        });
        return arr;
    }

    getObjectChildren(obj, level) {
        let json = [];
        let nlevel = level + 1;
        Object.keys(obj).map((key, idx) => {
            let type = Object.prototype.toString.call(obj[key]);
            if (type == '[object Object]') {
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    children: this.getObjectChildren(obj[key], nlevel)
                })
            } else if (type == '[object Array]') {
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    value: this.getArrayDisplayValue(obj[key]),
                    children: this.getArrayChildren(obj[key], nlevel)
                })
            } else {
                if (key === this.MAP_LON_VALUE && this.MAP_LAT_VALUE in obj) {
                    let bb = null;
                    if ('boundingBox' in obj) {
                        bb = obj['boundingBox'];
                    }
                    json.push({
                        name: key,
                        nameDisplay: key,
                        value: obj[key],
                        mapLon: obj[this.MAP_LON_VALUE],
                        mapLat: obj[this.MAP_LAT_VALUE],
                        mapBoundingBox: bb,
                        level: nlevel
                    })
                } else {
                    json.push({
                        name: key,
                        nameDisplay: key,
                        value: obj[key],
                        level: nlevel
                    })
                }
            }
        });
        return json;
    }

    getArrayChildren(arr, level, isImage=false) {
        let json = [];
        let nlevel = level + 1;
        Object.keys(arr).map((key, idx) => {
            let value = arr[key];
            let type = Object.prototype.toString.call(value);
            if (type == '[object Object]') {
                var nameDisplay = key;
                var childObj = value;
                if ('langCode' in value) {
                    nameDisplay = value['langCode'];
                    childObj = Object.assign({}, value);
                    delete childObj['langCode'];
                }
                else if ('label' in value) {
                    nameDisplay = value['label'];
                    childObj = Object.assign({},value);
                    delete childObj['label'];
                }
                else if ('value' in value) {
                    nameDisplay = value['value'];
                    childObj = Object.assign({}, value);
                    delete childObj['value'];
                }
                json.push({
                    name: key,
                    nameDisplay,
                    level: nlevel,
                    children: this.getObjectChildren(childObj, nlevel)
                })
            } else if (type == '[object Array]') {
                let image = false;
                if (key === this.IMG_NODE_VALUE && value.length > 0) {
                    image = true;
                }
                else if (key === this.STOCKS_NODE_VALUE && value.length > 0) {
                    value = this.formatStocks(value);
                }
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    value: this.getArrayDisplayValue(value),
                    isImage: image,
                    children: this.getArrayChildren(value, nlevel, image)
                })
            } else if (key !== '0') {
                json.push({
                    name: key,
                    nameDisplay: '',
                    value,
                    level: nlevel,
                    isImage
                })
            }
        });
        return json;
    }

    componentWillMount() {
        if (this.props.entityId) {
            // urlHandler.sendRequest('entities2', null, this.props.entityId, null, null, (response,txt,status) => {
            //     if (status == 200) {
                const response = this.props.getEntityData(this.props.entityId);
                    let json = [];
                    let level = 0;
                    
                    let type = 'GEO';
                    if ('type' in response) {
                        type = response['type'];
                    }

                    // Add our preferred fields first
                    this.state.preferedFields.forEach((field) => {
                        if (field in response) {
                            let value = response[field];
                            let type = Object.prototype.toString.call(value);
                            if (type == '[object Object]') {
                                json.push({
                                    name: field,
                                    nameDisplay: field,
                                    level, 
                                    children: this.getObjectChildren(value, level)
                                })
                            } else if (type == '[object Array]') {
                                let isImage = false;
                                if (field === this.IMG_NODE_VALUE && value.length > 0) {
                                    isImage = true;
                                    this.setState({
                                        headerImage: value[0]
                                    })
                                }
                                else if (field === this.STOCKS_NODE_VALUE && value.length > 0) {
                                    value = this.formatStocks(value);
                                }
                                json.push({
                                    name: field,
                                    nameDisplay: field,
                                    level,
                                    isImage,
                                    value: this.getArrayDisplayValue(value),
                                    children: this.getArrayChildren(value, level, isImage)
                                })
                            } else {
                                if (field === this.MAP_LON_VALUE && this.MAP_LAT_VALUE in response) {
                                    let bb = null;
                                    if ('boundingBox' in response) {
                                        bb = response['boundingBox'];
                                    }
                                    json.push({
                                        name: field,
                                        nameDisplay: field,
                                        value,
                                        mapLon: response[this.MAP_LON_VALUE],
                                        mapLat: response[this.MAP_LAT_VALUE],
                                        mapBoundingBox: bb,
                                        level
                                    })
                                } else {
                                    json.push({
                                        name: field,
                                        nameDisplay: field,
                                        value,
                                        level
                                    })
                                }
                            }
                        }
                    });

                    // Then the rest
                    Object.keys(response).map((key, idx) => {
                        if (this.state.preferedFields.indexOf(key) == -1) {
                            let value = response[key];
                            let type = Object.prototype.toString.call(value);
                            if (type == '[object Object]') {
                                json.push({
                                    name: key,
                                    nameDisplay: key,
                                    level, 
                                    children: this.getObjectChildren(value, level)
                                })
                            } else if (type == '[object Array]') {
                                let isImage = false;
                                if (key === this.IMG_NODE_VALUE && value.length > 0) {
                                    isImage = true;

                                    this.setState({
                                        headerImage: value[0]
                                    })
                                }
                                else if (key === this.STOCKS_NODE_VALUE && value.length > 0) {
                                    value = this.formatStocks(value);
                                }
                                json.push({
                                    name: key,
                                    nameDisplay: key,
                                    level,
                                    isImage,
                                    value: this.getArrayDisplayValue(value),
                                    children: this.getArrayChildren(value, level, isImage)
                                })
                            } else {
                                if (key === this.MAP_LON_VALUE && this.MAP_LAT_VALUE in response) {
                                    let bb = null;
                                    if ('boundingBox' in response) {
                                        bb = response['boundingBox'];
                                    }
                                    json.push({
                                        name: key,
                                        nameDisplay: key,
                                        value,
                                        mapLon: response[this.MAP_LON_VALUE],
                                        mapLat: response[this.MAP_LAT_VALUE],
                                        mapBoundingBox: bb,
                                        level
                                    })
                                } else {
                                    json.push({
                                        name: key,
                                        nameDisplay: key,
                                        value,
                                        level
                                    })
                                }
                            }
                        }
                    });

                    this.setState({
                        data: json,
                        rawJson: response,
                        type
                    });
                }
            // });
        // }
    }

	/**
	 * Return the nodes to be displayed in the tree view. This function is initially called
	 * if the root property is not specified in the tree view
	 * @param  {object} parent The parent object linked to the node, or null if the tree needs
	 *                         	to display the root nodes
	 * @return {any}        The list of roots, or a promise object
	 */
	getNodes(parent) {
        let lst = [];
        if (!parent && this.state.data) {
            lst = this.state.data;
        } else {
            if ('children' in parent) {
                lst = parent.children;
            }
        }
		return lst;
	}

	/**
	 * The title to be displayed, or any other composition of react components
	 * @param  {object} item The object returned by getNodes()
	 * @return {any}         String to be displayed as a title or a react component
	 */
	innerNode(item) {
        return item.nameDisplay;
	}

	/**
	 * React component that will wrap the node link. It will include 2 columns to be displayed
	 * using Twitter Bootstrap to make it responsive
	 * @param  {Component} content 	The react element containing the plus/leaf button and the title
	 * @param  {object} item    	The object linked to the node (returned by getNodes)
	 * @return {Component}         	A new component wrapping the given component
	 */
	outerNode(content, item) {
        let val = item.value;

        // Boolean values don't seem to get rendered correctly, so convert them to string.
        let type = Object.prototype.toString.call(val);
        if (type == '[object Boolean]') {
            val = val ? 'True' : 'False';
        }

		return (
			<div key={item.name} className="node-row">
				<div className="node-row-name">
					{content}
				</div>
                <div className="node-row-cols">
                    <div className="node-row-col-1">
                        {val}
                        {item.isImage && !this.externalUrlsDisable &&
                            <p>
                                <br/>
                                <img src={item.value} onError={this.nodeImageError}/>
                            </p>
                        }
                        {item.nameDisplay == this.MAP_LON_VALUE && item.mapLat && item.mapLon && !this.mapDisable &&
                            <div>
                                <br/>
                                {this.mapMetaCartaUrl ? 
                                    <MetaCartaMap className="map-container" 
                                        boundingBox={item.mapBoundingBox}
                                        lat={item.mapLat} 
                                        lng={item.mapLon}
                                        type={this.state.type}/>
                                    :
                                    <GoogleMap style={{width: '300px', height: '300px', borderRadius: '5px'}} 
                                        boundingBox={item.mapBoundingBox}
                                        lat={item.mapLat} 
                                        lng={item.mapLon}
                                        type={this.state.type}/>
                                }
                                <br/>
                            </div>
                        }
                    </div>
                </div>
			</div>
		);
	}

	/**
	 * Inform the tree if the node is a leaf, i.e, if the node has no other children
	 * @param  {[type]} item The object linked to the node, created by the <code>getNodes</code> function
	 * @return {boolean}     return true if the node is a leaf
	 */
	checkLeaf(item) {
        if ('children' in item) {
            if (item.children.length === 0) {
                return true;
            }
            return false;
        }
        return true;
	}

    imageError(e) {
        this.setState({
            headerImage: noImageAvailable
        });
    }

    nodeImageError(e) {
        e.target.src = noImageAvailable;
    }

    render() {

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0,0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '800px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
           <span id="rm_ShowEverythingDialog">
                {this.props.showLink ?
                    <button className="link-button" onClick={this.open}>{this.props.entityId}</button>
                :
                    <FinchButton primary={false} text="Show everything ..." submit={this.open}></FinchButton>
                }
                <ReactModal ref="propertiesId" 
                    isOpen={this.state.modalOpen}
                    contentLabel={this.props.entityName}
                    onRequestClose={this.close} 
                    onAfterOpen={this.afterOpen}
                    style={styles}
                    closeTimeoutMS={1000}>
                    <div className="properties-dialog">
                        <div className="properties-header">
                            <span>{this.props.entityName}</span>
                        </div>
                        <div className="properties-description">
                            <span className='fa fa-list-alt properties-icon'>&nbsp;</span>
                            Below is all the information Finch for Text knows about the entity {this.props.entityName}.    
                        </div>
                        <div className="properties-content">
                            <TreeView onGetNodes={this.getNodes}
                                innerRender={this.innerNode}
                                checkLeaf={this.checkLeaf}
                                outerRender={this.outerNode}
                                onChange={this.afterOpen} />
                        </div>
                        <div>
                            {this.state.rawJson && this.state.showJson &&
                            <div key="json-panel">
                                <JsonControl className="properties-json" results={this.state.rawJson}/>
                            </div>
                            }
                        </div>
                        <div className="properties-footer">
                            <button type="button" className="properties-default-button" onClick={this.close}>Ok</button>
                            <button type="button" className="properties-default-button left-button" onClick={this.showJson}>
                                {this.state.showJson ? 'Hide JSON' : 'Show JSON'}
                            </button>
                        </div>
                    </div>
                </ReactModal>
            </span>
        );
    };
}

export default ShowEverythingDialog;


